// Which phone this is, kept between visits.
//
// Lifted out of ws-client.js because two things need it now and they run at
// different times: the DOOR asks for a seat before any socket exists, and the
// SOCKET identifies itself long afterwards. Both have to send the same id or the
// two halves of "one live connection per phone" would be about different phones.
//
// It does two jobs, and neither makes it a credential — the server only ever
// compares it against something:
//
//   removal    an operator who kicks a seat bans this id, so scanning a
//              different chair's card does not undo it.
//   one place  a phone holds ONE seat and ONE socket. Every tab of a browser
//              shares this id (localStorage is per origin) while each tab has
//              its own seat token (sessionStorage is per tab) — which is exactly
//              how one person used to end up holding ten seats.
//
// localStorage, not sessionStorage, and that is the point of it: everything else
// this client keeps dies with the tab, and a ban that a page reload undoes is not
// a ban. Clearing site data clears this, which is the way out of this and is
// accepted — the alternative was banning by IP, and a hall shares a handful of
// carrier addresses between hundreds of people who did nothing.
//
// Wrapped because a browser in private mode, or one told to block site data,
// throws on the accessor itself rather than returning null. A phone with no id
// is still bannable by its code, and still gets in — it simply cannot be told
// apart from its own other tabs, which is the same position every phone was in
// before this existed.
const KEY = 'cs_device';

let cached = null;

export function deviceId() {
  if (cached !== null) return cached;
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID()
                              : String(Math.random()).slice(2) + Date.now().toString(36))
        .replace(/[^A-Za-z0-9_-]/g, '');
      localStorage.setItem(KEY, id);
    }
    cached = id;
  } catch {
    cached = '';
  }
  return cached;
}
